import React from 'react';
import './StarlinkPricing.scss';

const StarlinkPricing: React.FC = () => {
  const handleRequestQuote = () => {
    window.location.href = 'mailto:sales@shadowtracker.com?subject=Starlink Fleet Quote Request&body=Please provide the following information:%0D%0A%0D%0ANumber of vehicles:%0D%0ACompany name:%0D%0AContact name:%0D%0APhone number:%0D%0AEmail:%0D%0ALocation:%0D%0A%0D%0AAdditional requirements:';
  };

  const handleContactSales = () => {
    window.location.href = 'tel:+1234567890';
  };

  return (
    <section className="starlink-pricing" id="pricing">
      <div className="container">
        <h2>Enterprise Fleet Pricing</h2>
        <p className="subtitle">Custom solutions for fleets of all sizes</p>
        
        <div className="pricing-grid">
          <div className="price-card">
            <div className="card-header">
              <h3>Starter Fleet</h3>
              <p className="fleet-size">1-10 Vehicles</p>
            </div>
            <ul>
              <li><span className="check">✓</span>Hardwired installation</li>
              <li><span className="check">✓</span>Real-time GPS tracking</li>
              <li><span className="check">✓</span>Driver behavior monitoring</li>
              <li><span className="check">✓</span>365 Trac platform access</li>
              <li><span className="check">✓</span>Mobile app</li>
              <li><span className="check">✓</span>Email support</li>
            </ul>
            <button className="btn-secondary" onClick={handleRequestQuote}>
              Request Quote
            </button>
          </div>

          <div className="price-card featured">
            <div className="featured-badge">Most Popular</div>
            <div className="card-header">
              <h3>Professional Fleet</h3>
              <p className="fleet-size">11-50 Vehicles</p>
            </div>
            <ul>
              <li><span className="check">✓</span>Everything in Starter</li>
              <li><span className="check">✓</span>Route optimization</li>
              <li><span className="check">✓</span>Fuel efficiency tracking</li>
              <li><span className="check">✓</span>Geofencing alerts</li>
              <li><span className="check">✓</span>Maintenance scheduling</li>
              <li><span className="check">✓</span>Priority phone support</li>
              <li><span className="check">✓</span>Dedicated account manager</li>
            </ul>
            <button className="btn-primary" onClick={handleRequestQuote}>
              Request Quote
            </button>
          </div>

          <div className="price-card">
            <div className="card-header">
              <h3>Enterprise Fleet</h3>
              <p className="fleet-size">51+ Vehicles</p>
            </div>
            <ul>
              <li><span className="check">✓</span>Everything in Professional</li>
              <li><span className="check">✓</span>Custom integrations</li>
              <li><span className="check">✓</span>API access</li>
              <li><span className="check">✓</span>Advanced analytics</li>
              <li><span className="check">✓</span>Multi-location support</li>
              <li><span className="check">✓</span>On-site training</li>
              <li><span className="check">✓</span>24/7 dedicated support</li>
            </ul>
            <button className="btn-secondary" onClick={handleRequestQuote}>
              Request Quote
            </button>
          </div>
        </div>

        <div className="pricing-footer">
          <p className="contact-info">
            Need help choosing? Call us at <a href="tel:+1234567890">(123) 456-7890</a>
          </p>
          <p className="service-note">*All plans include professional installation and dual protection system</p>
        </div>
      </div>
    </section>
  );
};

export default StarlinkPricing;
